import { TouchableOpacity, View } from "react-native";
import { Text } from "@shared/components/text";
import { CustomRadio } from "@shared/components/md-design-system/Radio";
import { QuestionnaireQuestionOption } from "app/_modules/core/questionnaire";
import { useTranslation } from "react-i18next";

interface SingleChoiceOptionsProps {
  orderedOptions: QuestionnaireQuestionOption[];
  selectedValue?: string | null;
  onSelect: (value: string, label: string) => void;
}

export const SingleChoiceOptions = ({ orderedOptions, selectedValue, onSelect }: SingleChoiceOptionsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Text>{t("screens.activities.questionnaire.selectOneOption")}</Text>
      <View className="flex-col gap-2">
        {orderedOptions.map((option) => (
          <TouchableOpacity
            key={option.id || option.value}
            className={`flex-row items-center justify-start gap-2 p-4 border rounded-lg ${
              selectedValue === option.value
                ? 'border-secondary-600 bg-secondary-100'
                : 'border-gray-300 bg-white'
            }`}
            onPress={() => onSelect(option.value, option.label)}
            activeOpacity={0.7}
          >
            <CustomRadio
              checked={selectedValue === option.value}
              onChange={() => onSelect(option.value, option.label)}
            />
            <Text>{option.label}</Text>
          </TouchableOpacity>
        ))}
      </View>
    </>
  );
};
